document.addEventListener("product:variant-change", function (evt) {
  const variant = evt.detail.variant;
  const klaviyoBIS = document.querySelector('.klaviyo-bis-trigger');

  if (!klaviyoBIS) return;

  klaviyoBIS.style.display = variant.available ? 'none' : '';

  const images = document.querySelectorAll('.draw-circle');
  
  images.forEach(img => {
    const src = img.getAttribute('src');
    // Reset the src with a cache-buster to restart the animation
    img.setAttribute('src', src);
  });

  // Replay lottie animation
  const lottiePlayer = document.querySelectorAll('.product__chip.selected lottie-player')[0];
  lottiePlayer.pause(); // Pause first
  lottiePlayer.seek(0); // Go to beginning (0 frames or 0%)
  lottiePlayer.play();  // Start playing
});

/* Complimentary Products */

(() => {
  if (customElements.get('complementary-products')) {
    return;
  }

  class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
      this.options = {};
    }

    connectedCallback() {
      this.initSlider();
    }

    initSlider() {
      if (!this.querySelector('[data-slider]')) return;

      this.options = {
        navigation: {
          prevEl: this.querySelector('[data-prev]'),
          nextEl: this.querySelector('[data-next]'),
        },
        slidesPerView: this.getAttribute('data-mobile-products-per-view'),
        spaceBetween: 10,
        breakpoints: {
          750: {
            slidesPerView: this.getAttribute('data-products-per-view'),
          },
        },
      };

      if (this.hasAttribute('data-autoplay')) {
        this.options.autoplay = {
          delay: this.dataset.autoplaySpeed,
        };
      }

      import(flu.chunks.swiper).then(({ Swiper, Navigation, Autoplay }) => {
        this.options.modules = [Navigation, Autoplay];

        this.slider = new Swiper(
          this.querySelector('[data-slider]'),
          this.options,
        );
      });
    }
  }

  customElements.define('complementary-products', ComplementaryProducts);
})();

/* Sticky A2C */

(function() {
  let observer

  function initStickyButton() {
    const btn = document.querySelector('.template-product .product__details .product-form__cart-submit.btn')
    if (!btn) return

    let sentinel = document.querySelector('#sticky-sentinel')
    if (!sentinel) {
      sentinel = document.createElement('div')
      sentinel.id = 'sticky-sentinel'
      sentinel.style.width = '1px'
      sentinel.style.height = '1px'
      btn.parentNode.insertBefore(sentinel, btn)
    }

    if (observer) observer.disconnect()

    observer = new IntersectionObserver(([entry]) => {
      const rect = entry.boundingClientRect
      if (rect.bottom < 0) {
        btn.classList.add('sticky')
      } else {
        btn.classList.remove('sticky')
      }
    }, { threshold: 0 })

    observer.observe(sentinel)
  }

  window.addEventListener('DOMContentLoaded', initStickyButton)
  window.addEventListener('resize', initStickyButton)
})();


/* Size Guide Slider */
(() => {
  function initSizeguideSliders() {
    document.querySelectorAll('[data-sizeguide-slider]').forEach((component) => {
      const sliderEl = component.querySelector('[data-slider]');

      if (!sliderEl || component.dataset.initialized === 'true') return;

      component.dataset.initialized = 'true';

      import(flu.chunks.swiper).then(({ Swiper, Navigation }) => {
        const slider = new Swiper(sliderEl, {
          modules: [Navigation],
          slidesPerView: 1,
          spaceBetween: 30,
          observer: true,
          observeParents: true,
          navigation: {
            prevEl: component.querySelector('[data-prev]'),
            nextEl: component.querySelector('[data-next]'),
          },
        });

        setTimeout(() => {
          slider.update();
        }, 50);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initSizeguideSliders);
})();